import { Star, ShieldCheck } from "lucide-react";
import { BACKEND } from "@/lib/api";
import { Reveal, SectionHead } from "./Reveal";

function Stars({ value, size = 14 }) {
  return (
    <span className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} size={size} className={n <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"} />
      ))}
    </span>
  );
}

export { Stars };

export default function ReviewsSection({ reviews = [] }) {
  if (reviews.length === 0) return null;
  return (
    <section id="reviews" className="py-24 bg-white border-y border-slate-100">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          index="05" label="Student Reviews"
          title="Students kya keh rahe hain"
          sub="Sirf verified khareedne wale hi review de sakte hain — aapka trust, hamara promise."
        />
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="reviews-grid">
          {reviews.slice(0, 6).map((r, i) => (
            <Reveal key={r.id} delay={Math.min(i * 0.07, 0.35)}>
              <div className="flex h-full flex-col rounded-3xl border border-slate-200 bg-cream p-6 card-lift" data-testid={`review-card-${r.id}`}>
                <Stars value={r.rating} />
                {r.photo_url && (
                  <img
                    src={`${r.photo_url.startsWith("/api") ? BACKEND : ""}${r.photo_url}`}
                    alt="Student notes"
                    loading="lazy"
                    className="mt-4 h-40 w-full rounded-2xl object-cover border border-slate-200"
                    data-testid={`review-photo-${r.id}`}
                  />
                )}
                <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-700">"{r.text}"</p>
                <div className="mt-5 flex items-center justify-between gap-3 border-t border-slate-200 pt-4">
                  <div className="min-w-0">
                    <p className="flex items-center gap-1.5 font-display text-sm font-bold text-slate-900">
                      {r.name}
                      {r.verified && (
                        <span className="inline-flex items-center gap-1 rounded-full bg-emerald-500/10 px-2 py-0.5 text-[10px] font-bold text-emerald-600">
                          <ShieldCheck size={11} /> Verified Buyer
                        </span>
                      )}
                    </p>
                    <p className="mt-0.5 truncate text-xs text-slate-400">{r.product_title}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
